import TableAHSF from "../../../Components/TableAHSF";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setRefreshTable } from "../../../Redux/Reducers/Shared/VariousVariables";
import PopupAHSF from "../../../Components/PopupAHSF";
import {
  decryptToken,
  encryptToken,
} from "../../../Services/Encryption/EncryptionParams";
// import ActivitesForm from "./ActivitesForm";
import ButtonAHSF from "../../../Components/ButtonAHSF";
import { DeleteActivities } from "../../../Redux/Reducers/ReportStage/Activities";
import Swal from "sweetalert2";
import loadConfig from "../../../Services/Api/ApiServices";
import { GetSpecificRowReportByApplicationInfo } from "../../../Redux/Reducers/ReportStage/Report";
import SharedDiv from "../../../Components/SharedDiv/SharedDiv";

const ReportStage = (props) => {
  const match = window.location.pathname; // قراءة النص بعد أول "/"
  const encryptedToken = match.split("/");
  var guid =
    encryptedToken[encryptedToken.length - 1] != null
      ? decryptToken(encryptedToken[encryptedToken.length - 1])
      : null;
  // const dispatch = useDispatch();
  const ReportRow = useSelector((state) => state.ReportStatus.ReportRowByAppId);
  const ChangeStatusReportStage = useSelector(
    (state) => state.StartProgressReportReducer.ChangeStatusReportStage
  );
  const AddActivitesResult = useSelector(
    (state) => state.Activities.AddActivities
  );
  const [jsonData, setJsonData] = useState({});
  const [activitiesObjectivesId, setactivitiesObjectivesId] = useState(null);
  const arrayDataCheckBoks = useSelector(
    (state) => state.arrayDataCheckBoks.arrayDataCheckBoks
  );
  const state = useSelector((state) => {
    return {
      jsonData: state.FetchDataJson.JsonData,
    };
  });
  const dispatch = useDispatch();
  const [popUpBodyStatus, setPopUpBodyStatus] = useState(false);
  const [popUpBodyAddStatus, setpopUpBodyAddStatus] = useState(false);
  const navigate = useNavigate();
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
  const RequestAccessor = [
    {
      KeyName: "reportingPhaseName",
      ShowStatus: true,
      NmaeColumn: "المرحلة",
      TotalNumber: false,
      DropdownFiltration: {
        keyTextName: "applicationNumber",
        keyValueName: "aI_ApplicationInformationId",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "reportDuration",
      ShowStatus: true,
      NmaeColumn: "مدة المرحلة",
      TotalNumber: false,
      DropdownFiltration: {
        keyTextName: "applicationNumber",
        keyValueName: "aI_ApplicationInformationId",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "statusNameBeneficiary",
      ShowStatus: true,
      NmaeColumn: "حالة المرحلة",
      TotalNumber: false,
      DropdownFiltration: {
        keyTextName: "applicationNumber",
        keyValueName: "aI_ApplicationInformationId",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "approvalAttachmentPathName",
      ShowStatus: true,
      NmaeColumn: "مرفق المرحلة",
      TotalNumber: false,
      DropdownFiltration: {
        keyTextName: "applicationNumber",
        keyValueName: "aI_ApplicationInformationId",
      },
      DropdownFiltrationStatus: false,
      FileCostume:true,
      
      GroupOfColumns: false,
      typeColumn: "file",
    },
  ];
  const RequestsManagerBtns = [
    {
      Click: async (e) => {
        var objects = JSON.parse(e.target.value);

        setactivitiesObjectivesId(objects.activitiesObjectivesId);
        setPopUpBodyStatus(true);
        navigate(
          `/SRFund/ReportStageForm/${objects.reportId}/${objects.reportStageId}`
        );
        console.log(objects, "objects");
      },
      content: "",
      className: "bi bi-pencil-square",
      id: "editBtn",
      title: "تعديل",
      ShowStatus: true,
      InitialScreeningAssessment: true,
       CurrentSatge: true,
    },
  ];

  const getJson = async () => {
    var json = await loadConfig();
    // //console.log(json,"malwk");

    setJsonData(json);
  };
  useEffect(() => {
    setJsonData(getJson());
  }, []);

  const RequestsManagerColumns = [];
  // send to read props popup
  const PopupOPjectData = {
    isPopupOpenStatus: popUpBodyStatus,

    isPopupOpenFunction: () => {},
    componentBody: <></>,

    title: "النشاط",
    maxWidth: "500px",
    maxHeight: "500px",
    idssss: "SecondarySectors",
  };
  const shouldDisableFields = "";
  useEffect(() => {
    dispatch(
      GetSpecificRowReportByApplicationInfo({
        applicationInformationId:
          localStorage.getItem("ApplicationInformationId") || guid,
      })
    );
  }, []);

  console.log(ReportRow, "ReportRow");
  useEffect(() => {
    dispatch(setRefreshTable());
  }, [ChangeStatusReportStage]);
  return (
    <>
      <SharedDiv
        showTitle={true}
        titleName="مراحل التقرير"
        child={[
          <>
            {ReportRow?.reportId ? (
              <>
                <TableAHSF
                  culomEdite={culomEdite}
                  RequestsManagerValue={true}
                  AllValueAction={true}
                  uniqueValue={"taskId"}
                  valueButtonAction={"taskId"}
                  URL={`api/ReportStage/GetAllReportStageForManager`}
                  UrlBody={{
                    reportId: ReportRow?.reportId,
                  }}
                  staticKeyEdite={staticKeyEdite}
                  AddFunctionButtonPopup={false}
                  AddFunctionButtonPopupFunction={() => {
                    navigate(
                      `/SRFund/report/AddStagesContainers/${props.reportId}`
                    );
                  }}
                  accessor={RequestAccessor}
                  titelTable={""}
                  selectRowNumber={true}
                  checkBoksColumName=""
                  sort={true}
                  pagination={true}
                  AppStatus={true}
                  tableBtn={false}
                  sortTable={true}
                  keyNameSort={"dateCreate"}
                  uniqeKeyName={"taskId"}
                  dateKey="dateCreate"
                  dateformat="DD/MM/YYYY h:mm a"
                  arrayNameSort={["applicationNumber"]}
                  search={true}
                  openPopupState={false}
                  DropdownArrayFiltration={[]}
                  DropdownFiltration={false}
                  exportData={true}
                  checkBoks={false}
                  uniqeKeyNameRedux={"tasksList"}
                  nameColumAction=""
                  total={false}
                  arrayButton={RequestsManagerBtns}
                  ArrayNameDataColum={RequestsManagerColumns}
                  columnKeyNameArray={[
                    { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
                  ]}
                  PopupOPjectData={PopupOPjectData}
                  popUpTitle={"معلومات الطلب"}
                  popUpBody={
                    //   <PopupAHSF
                    //     idssss="SecondarySectors"
                    //     isPopupOpenStatus={popUpBody.isPopupOpenStatus}
                    //     isPopupOpenFunction={popUpBody.isPopupOpenFunction}
                    //     title={popUpBody.title}
                    //     componentBody={popUpBody.componentBody}
                    //     maxWidth={popUpBody.maxWidth}
                    //     maxHeight={popUpBody.maxHeight}
                    //   />
                    <></>
                  }
                />
              </>
            ) : (
              <></>
            )}
          </>,
        ]}
        showButton={true}
        id_Title="withBtnTitle"
        buttonComponent={
          // Display a button to show the budget summary
          <ButtonAHSF
            id={"btnTitle"}
            type={"submitter"}
            onClick={() => {
              if(   window.location.href.includes("manager") == true){
                navigate(`/SRFund/manager/report/EmployeeTransfers/${ReportRow?.reportId}`);

              }else{

                navigate(`/SRFund/EmployeeTransfers/${ReportRow?.reportId}`);
              }
            }}
            disabled={false}
            title={"اعدادات التقرير"}
            text={"اعدادات التقرير"}
            show={true}
          />
        }
      />
    </>
  );
};
export default ReportStage;
